import React from 'react';

interface IOSMoreButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

/**
 * iOS 风格的更多操作按钮组件
 * 显示为三个点的图标，点击时触发操作表单
 */
export const IOSMoreButton: React.FC<IOSMoreButtonProps> = ({ onClick, disabled = false }) => {
  return (
    <button
      onClick={onClick}
      className={`p-2 rounded-full text-ios-blue dark:text-ios-dark-blue ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
      disabled={disabled}
    >
      <svg className="w-5 h-5 flex-shrink-0" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="6" r="1" fill="currentColor" />
        <circle cx="12" cy="12" r="1" fill="currentColor" />
        <circle cx="12" cy="18" r="1" fill="currentColor" />
      </svg>
    </button>
  );
};
